import { render, staticRenderFns } from "./ReminderFields.vue?vue&type=template&id=68d632c8&lang=pug"
import script from "./ReminderFields.vue?vue&type=script&lang=ts"
export * from "./ReminderFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports